/*!
 * MosaicView - Vue mosaïque de cartes pour IconsView
 */

import CardView from './CardView';

export default class MosaicView extends CardView {
    constructor(plugin) {
        super(plugin, 'mosaic');
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentViewConf = myself.getViewConfig('mosaic') || {};
        const currentIconSize = myself.getViewIconSize('mosaic');

        myself.viewThumbsHeight = currentIconSize;
        myself.viewThumbsWidth = currentIconSize;
        myself.viewItemWidthRatio = currentViewConf.ratio || 4;
        myself.viewItemWidthMin = currentViewConf.minWidth || 200;
        myself.viewItemWidthMax = currentViewConf.maxWidth || 400;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const mosaicFields = myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, mosaicFields);

        let countMosaicHtml = '';
        if (myself.shouldShowCount(data, 'mosaic')) {
            countMosaicHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        let customItemStyle = '';
        if (currentViewConf.width || currentViewConf.size) {
            const w = currentViewConf.width || currentViewConf.size;
            customItemStyle = 'style="width:' + (typeof w === 'number' ? w + 'px' : w) + ';"';
        }

        const code = '<div class="' + currentClassAll + '" ' + customItemStyle + '><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(myself.viewThumbsWidth, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + countMosaicHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div>';

        const currentIcon = $(code);
        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    resize() {
        const myself = this.plugin;
        const currentViewConf = myself.getViewConfig('mosaic') || {};
        const canvaWidth = myself.element.find('.view').width();
        if (!canvaWidth) return;

        // Si cols est spécifié explicitement dans le template (ex: cols: 3 ou cols: 4)
        if (currentViewConf.cols || currentViewConf.columns) {
            const cols = parseInt(currentViewConf.cols || currentViewConf.columns, 10);
            const gap = currentViewConf.gap !== undefined ? currentViewConf.gap : 16;
            const computedWidth = Math.floor((canvaWidth - (gap * (cols - 1))) / cols);
            myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').css('width', computedWidth);
            return;
        }

        // Sinon largeur dynamique basée sur targetWidth ou thumbsWidth configuré
        const targetWidth = currentViewConf.width || currentViewConf.size || 320;
        const marginFix = currentViewConf.gap !== undefined ? currentViewConf.gap : 16;
        const colCount = canvaWidth / (targetWidth + marginFix);
        const colCountFix = Math.max(1, Math.ceil(colCount));
        const adjustedWidth = Math.floor((canvaWidth / colCountFix) - marginFix);

        myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').css('width', adjustedWidth);
    }

    getZoomLimits() {
        return { enabled: true, min: 48, max: 128 };
    }
}
